// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Login-module__loginPanel-kZM0t {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.nightbot-Login-module__loginPanelText-JRT2b {
  --text-color: var(--text-secondary);
}

.nightbot-Login-module__loginPage-OYgMk {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  display: flex;
}

.nightbot-Login-module__panel-yjl32 {
  flex: 1;
  max-width: 400px;
  padding: 16px;
}

.nightbot-Login-module__loginPanelContainer-QgIxE {
  flex: 1;
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
  height: 100%;
  background-color: var(--background-secondary);
}

.nightbot-Login-module__loginArtContainer-_bPXW {
  flex: 1;
}

@media (max-width: 768px) {

.nightbot-Login-module__loginArtContainer-_bPXW {
    display: none;
}
  }

.nightbot-Login-module__loginArt-aCNXu {
  width: 100%;
  height: 100%;
}

.nightbot-Login-module__soopIcon-frmj0, .nightbot-Login-module__noiceIcon-O0Mms, .nightbot-Login-module__trovoIcon-MnviV {
  width: 20px;
  height: 20px;
}

.nightbot-Login-module__soopIcon-frmj0 {
  width: 24px;
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Login.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,OAAO;AAKT;;AAHE;;AAHF;IAII,aAAa;AAEjB;EADE;;AAGF;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".loginPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.loginPanelText {\n  --text-color: var(--text-secondary);\n}\n\n.loginPage {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  display: flex;\n}\n\n.panel {\n  flex: 1;\n  max-width: 400px;\n  padding: 16px;\n}\n\n.loginPanelContainer {\n  flex: 1;\n  display: grid;\n  place-items: center;\n  height: 100%;\n  background-color: var(--background-secondary);\n}\n\n.loginArtContainer {\n  flex: 1;\n\n  @media (max-width: $mantine-breakpoint-sm) {\n    display: none;\n  }\n}\n\n.loginArt {\n  width: 100%;\n  height: 100%;\n}\n\n.soopIcon, .noiceIcon, .trovoIcon {\n  width: 20px;\n  height: 20px;\n}\n\n.soopIcon {\n  width: 24px;\n  height: 24px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginPanel": `nightbot-Login-module__loginPanel-kZM0t`,
	"loginPanelText": `nightbot-Login-module__loginPanelText-JRT2b`,
	"loginPage": `nightbot-Login-module__loginPage-OYgMk`,
	"panel": `nightbot-Login-module__panel-yjl32`,
	"loginPanelContainer": `nightbot-Login-module__loginPanelContainer-QgIxE`,
	"loginArtContainer": `nightbot-Login-module__loginArtContainer-_bPXW`,
	"loginArt": `nightbot-Login-module__loginArt-aCNXu`,
	"soopIcon": `nightbot-Login-module__soopIcon-frmj0`,
	"noiceIcon": `nightbot-Login-module__noiceIcon-O0Mms`,
	"trovoIcon": `nightbot-Login-module__trovoIcon-MnviV`
};
export default ___CSS_LOADER_EXPORT___;
